import {
  resolve,
} from "@/components/charts/common";

function callFunction(item, dashboard) {
  try {
    const grids = dashboard.layout.grids;
    for (let i = 0; i < grids.length; i++) {
      const activeChart = grids[i].layers[0];
      if (item && typeof activeChart[item.attr_call_function] != 'undefined') {
        activeChart[item.attr_call_function](item);
        // console.log("c", c);
        // chart.chartData.expandToPageChart = c;
      }
    }
  } catch (error) {
    // console.log("callFunction error", error);
  }
}

// import { createProject, getProjects } from '@/models/project'
import Vue from 'vue';
function stringForId(str) {
  return str.replace(/[\W_]+/g, " ").toLowerCase();
}
// function getFirstIndex(user, charts) {

// }

export default {
  mInit(state, charts) {
    Vue.set(state, 'charts', charts);
    if (charts.length) {
      try {
        // const index = getDashboardIndex(state.user, charts);
        // charts[index].setTree(state);
        // Vue.set(state, 'chart', charts[index]);
      } catch(error) {
        // 
      }
    }
  },
  mAdd(state, chart) {
    Vue.set(state, "chart", chart);
    state.charts.push(chart);
  },
  mDelete(state, chart) {
    state.charts.splice(state.charts.indexOf(chart), 1);
    if (state.charts.length) {
      state.chart = state.charts[0];
    } else {
      state.charts = [];
      state.chart = {};
    }
  },
  mSetFilter(state, params) {
    //console.log(params);
    state.filters[params.id] = params.filter;
    let layers = state.chart.getLayers();
    //console.log(layers);
    for (let i = 0; i < layers.length; i++) {
      let layer = layers[i]
      if (typeof layer.id != "undefined" && !params.exclude.includes(layer.id)) {
        layer.hydrate();
      }
    }
  },
  mRemoveFilter(state, params) {
    if (typeof state.filters[params.id] != "undefined") {
      delete state.filters[params.id];
    }
    let layers = state.chart.getLayers();
    for (let i = 0; i < layers.length; i++) {
      if (typeof layers[i].id != "undefined" && !params.exclude.includes(layers[i].id)) {
        layers[i].hydrate();
      }
    }
  },
  mSetEditable(state, editable) {
    Vue.set(state, "editable", editable);
  },
  mToggleEditable(state, editable) {
    Vue.set(state, "editable", !editable);
    console.log('editable', state.editable);
  },
  mSetCharts(state, charts) {
    // console.log("mSetCharts", mSetCharts);
    Vue.set(state, "charts", charts);
  },
  mSetDataSources(state, dataSources) {
    Vue.set(state, "dataSources", dataSources);
  },
  mLoad(state, chart) {
    for (let i = 0; i < state.charts.length; i++) {
      if (state.charts[i].id == chart.id) {
        state.charts[i] = chart;
      }
    }
    if (typeof state.setTree != "undefined") {
      chart.setTree(state);
    }
  },
  mSet(state, chart) {
    for (let i = 0; i < state.charts.length; i++) {
      if (state.charts[i].id == chart.id) {
        state.charts[i] = chart;
      }
    }
    if (typeof state.setTree != "undefined") {
      chart.setTree(state);
    }

    Vue.set(state, "chart", chart);
    console.log("setting chart", chart);
    //  console.log("state.chart");
    //  console.log(state.chart);
  },
  mSetDialog(state, bool) {

    Vue.set(state, "dialog", bool);
    //  console.log("state.chart");
    //  console.log(state.chart);
  },
  mSetName(state, name) {
    state.chart.name = name;
  },
  mSetType(state, type) {
    // console.log('type', type);
    state.chart.type = type;
    state.chart.reset();
    state.chart.setParameters();

  },
  mLoadParametersAndHydrator(state, activeLayer) {

    activeLayer.loadParametersAndHydrator();

  },
  mSetActiveLayerType(state, type) {
    // console.log('type', type);

    //  console.log('activeLayer', activeLayer);
    //console.log('type', type);
    // activeLayer.setType(type);
    state.activeLayer.type = type;
    // state.activeLayer.reset();
    // state.activeLayer.setParameters();
    // state.activeLayer.loadDefaults();
  },
  mChangeChart(state, type) {
    // console.log('type', type);

    //  console.log('activeLayer', activeLayer);
    //console.log('type', type);
    // activeLayer.setType(type);
    state.activeLayer.type = type;
    state.activeLayer.setType(type);
    state.activeLayer.hydrate();

    state.activeLayer.reset();
    state.activeLayer.setParameters(true);
    state.activeLayer.loadDefaults();


  },
  mSetLayerType(state, type) {
    // console.log('type', type);

    //  console.log('activeLayer', activeLayer);
    //console.log('type', type);
    // activeLayer.setType(type);
    // state.activeLayer.type = type;
    // state.activeLayer.reset();
    // state.activeLayer.setParameters();
    // state.activeLayer.loadDefaults();
  },
  mSetLayoutUsingBreakpoint(state, breakpoint) {
    state.chart.setLayoutUsingBreakpoint(breakpoint);
  },
  mSetTypeGroup(state, typeGroup) {
    state.typeGroup = typeGroup
  },
  mSetProjectId(state, projectId) {
    Vue.set(state, "projectId", projectId);
  },
  mLoading(state, bool) {
    Vue.set(state, "loading", bool);
  },
  mProgressValue(state, value) {
    Vue.set(state, "progressValue", value);
  },
  mAddGrid(state, grid) {
    let layers = grid.layers;
    for (let i = 0; i < layers.length; i++) {
      if (typeof layers[i].id != "undefined") {
        layers[i].setTree(state);
        layers[i].loadParametersAndHydrator();
        layers[i].hydrate();
      }
    }
    state.chart.layout.grids.push(grid);
  },
  mToggleGridMenu(state, b) {
    if (typeof b != "undefined") {
      state.showGridMenu = b;
      return true;
    }
    state.showGridMenu = !state.showGridMenu;
  },
  mSetActiveGrid(state, grid) {

    if (state.activeGrid.id && state.activeGrid.id == grid.id) {
      //    state.activeGrid = {id: null};
      //  state.activeLayer = {id: null};
      //  state.activeGridId = null;
      //  state.showGridMenu = false;
      return;
    }

    state.showGridMenu = true;
    state.activeGrid = grid;

    if (grid.layers.length) {
      // console.log("setting active layer");
      state.activeLayer = grid.layers[grid.layers.length - 1];
      // state.activeLayer.loadParametersAndHydrator();
      // state.activeLayer.hydrate();
    }
    state.activeGridId = grid.id;
  },
  mLoadActiveLayer(state) {
    state.activeLayer.setParameters();
    state.activeLayer.loadDefaults();
    state.activeLayer.setTree(state);
    state.activeLayer.loadDataSources();
    state.activeLayer.loadDefaultDataSources();
  },
  mReInitializeGridsById(state, id) {
    try {
      const chart = state.charts.find((item) => item.layout.id === id);
      chart.reInitialiseGrids();
    } catch(error) {
      // alert(error);
    }
    
  },
  mInitializeGrids(state, chart) {
    // console.log('mInitializeGrids');
    if (typeof chart != "undefined") {
      if (typeof chart.initialiseGrids != "undefined" && chart.initialiseGrids) {
        // console.log("mInitializeGrids", chart);
        chart.initialiseGrids(state);
      }

    } else if (typeof state.chart.initialiseGrids != "undefined" && state.chart.initialiseGrids) {
      state.chart.initialiseGrids(state);
    }
  },
  mOpenDashboard(state, { chart, name }) {

    //alert("in");

    let layout = state.charts.find(item => item.id == name);
    chart.chartData.expandToPageChart = null;
    if (!layout) {
      layout = state.charts.find(item => stringForId(item.name) == stringForId(name));
    }

    // alert(name);

    if (layout) {
      // alert("found");
      chart.chartData.expandToPageChart = layout;
    }
    // chart.chartData.expandToPageChart = c;

    //this.setSubChart({chart:this.chart, item: this.chart.dataSource.filteredData[0]})

    if (typeof chart.chartData.expandToPageChart != 'undefined' && chart.chartData.expandToPageChart && typeof chart.chartData.expandToPageChart.initialiseGrids != 'undefined' && chart.chartData.expandToPageChart.initialiseGrids != null) {
      chart.chartData.expandToPageChart.parentChart = chart;
      chart.chartData.expandToPageChart.initialiseGrids(state);

      state.subChart = chart;
      state.subChart.hasDialog = true;
      state.subChartDialog = true;
      // console.log("state.subChartDialog", state.subChartDialog);
    }
  },
  mSetSubChart(state, { chart, item, settings }) {
    // alert("mSetSubChart");
    // console.log("mSetSubChart");
    // console.log("item", item);
    // console.log("settings", settings);
    //console.log(chart);
    // alert('hey ' + item.id);
    // console.log("state.chart", state.chart);
    // console.log("item", item);
    // console.log("settings", settings);

    chart.loadSubChartInDialog(settings, item, function () {
      let expandToPageChart = false;
      let callFunctionExist = false;
      if (typeof chart.chartData.expandToPageChart != 'undefined' && chart.chartData.expandToPageChart && typeof chart.chartData.expandToPageChart.initialiseGrids != 'undefined' && chart.chartData.expandToPageChart.initialiseGrids != null) {
        expandToPageChart = true;
      }
      if (typeof item.attr_call_function != "undefined") {
        callFunctionExist = true;
      }

      try {
        //console.log("settings", settings);
        const functionType = settings.functionType;
        if (functionType == 'openDashboard') {
          expandToPageChart = true;
          // callFunctionExist = true;
        }
      } catch (error) {
        console.log("error", error);
      }

      if (settings && typeof settings.settings === 'undefined') {
        settings.settings = settings;
      }
      

      let fullscreen = resolve("settings.fullscreen", settings, null);
      if(fullscreen === null) {
        fullscreen = resolve("dialog.fullscreen", settings, true);
      }
      Vue.set(state, 'fullscreen', fullscreen);

      // console.log("state.fullscreen 1", fullscreen);
      // console.log("state.fullscreen 2", state.fullscreen);
      // console.log("state.fullscreen settings", settings);
      // alert(JSON.stringify(settings));
      let dialogTitle = resolve("settings.title", settings, null);
      if(dialogTitle === null) {
        dialogTitle = resolve("dialog.title", settings, "");
      }
      state.dialogTitle = dialogTitle;

      if (typeof item != "undefined") {
        // console.log(state.charts);
        // console.log("item defined", item);
        if (typeof item.attr_popup != "undefined") {
          chart.chartData.expandToPageChart = null;
          for (let i = 0; i < state.charts.length; i++) {
            let c = state.charts[i];
            // console.log(stringForId(c.name));
            // console.log(stringForId(item.attr_popup));
            if (item.attr_popup == c.id || stringForId(item.attr_popup) == stringForId(c.name)) {
              // console.log("c", c);
              chart.chartData.expandToPageChart = c;
            }
          }
        }

        state.parameterisedFilterObject = JSON.parse(JSON.stringify(item));


        if (callFunctionExist) {

          try {
            if (!expandToPageChart) {
              callFunction(item, state.chart);
              callFunction(item, state.subChart.chartData.expandToPageChart);
            }
          } catch (error) {
            // 
          }

          // console.log("debugitem", 1);
          chart.chartData.expandToPageChart = null;


        }


        // console.log("setting parameterisedFilterObject", state.parameterisedFilterObject);
      }
      if (expandToPageChart) {
        // const childDashboard = chart.chartData.expandToPageChart;
        // console.log("expandToPageChart", childDashboard.id);
        // console.log("expandToPageChart", childDashboard.getLoadedStatus());
        chart.chartData.expandToPageChart.parentChart = chart;

        // console.log('Initialis grid item', item);

        state.subChart = chart;
        chart.chartData.expandToPageChart.initialiseGrids(state, item, settings);



        if (callFunctionExist) {
          try {
            // callFunction(item, state.chart);
            callFunction(item, state.subChart.chartData.expandToPageChart);
          } catch (error) {
            // 
          }

        }
        state.subChart.hasDialog = true;
        state.subChartDialog = true;
        // console.log("debugitem", 2);
        // console.log("state.subChartDialog", state.subChartDialog);
      }
    });
  },
  mReloadChartLayout(state, chart) {
    try {
      const layout = state.charts.find((item) => item.id === chart.getParentId());
      layout.reInitialiseGrids();
    } catch(error) {
      // 
    }

  },
  mLoadChart(state, chart) {
    for (let i = 0; i < state.charts.length; i++) {
      if (state.charts[i].id == chart.id) {
        // console.log("found chart");
        state.charts[i] = chart;
      }
    }
    if (typeof chart.setTree != "undefined") {
      chart.setTree(state);
    }
    if (chart) {
      chart.initialiseGrids(state);
    }
    // console.log("mLoadChart chart.schemaLoaded", chart.schemaLoaded);
  },
  mResetSubChart(state, chart, row) {
    state.subChart = {};
    state.subChartDialog = false;
    state.parameterisedFilterObject = {};
  },
  mOpenSubChart(state) {
    state.subChartDialog = true;
  },
  mCloseSubChart(state) {
    state.subChartDialog = false;
    try {
      const autoRefresh = state.subChart.parameters.autoRefresh;
      // alert(autoRefresh);
      if (autoRefresh) {
        // alert('close');
        state.subChart.hydrate();
      } else {
        state.chart.reInitialiseGrids();
      }
    } catch (error) {
      // 
      // alert(error);
    }
    state.subChart = {};

    state.parameterisedFilterObject = {};
  },
  mSetActiveLayer(state, layer) {

    layer.setParameters();
    layer.setTree(state);
    layer.loadDataSources();
    layer.loadDefaultDataSources();

    state.activeLayer = layer;
  },
  mRemoveGrid(state, grid) {
    state.chart.layout.grids.splice(state.chart.layout.grids.indexOf(grid), 1);
  },
  mStartDisplay(state) {
    state.display = true;
  }
};
